module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [_c('breadcrumbs', {
    attrs: {
      "crumbs": [{
        name: (_vm.participantSingularName + " Directory"),
        link: 'Participant Directory'
      }, (_vm.participantSingularName + " Dashboard")]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 db-column",
    attrs: {
      "id": "first-column"
    }
  }, [_c('widget', {
    attrs: {
      "name": _vm.widgets.widgetsFirst,
      "type": 'widgetsFirst',
      "draggable": ".portlet"
    },
    on: {
      "passWidgets": _vm.widgetsData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 db-column",
    attrs: {
      "id": "second-column"
    }
  }, [_c('widget', {
    attrs: {
      "name": _vm.widgets.widgetsSecond,
      "type": 'widgetsSecond',
      "draggable": ".portlet"
    },
    on: {
      "passWidgets": _vm.widgetsData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 db-column",
    attrs: {
      "id": "third-column"
    }
  }, [_c('widget', {
    attrs: {
      "name": _vm.widgets.widgetsThird,
      "type": 'widgetsThird',
      "draggable": ".portlet"
    },
    on: {
      "passWidgets": _vm.widgetsData
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d9ae986","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ParticipantDashboard.vue
// module id = 1661
// module chunks = 1